import moment from 'moment';
import { ReactComponent as NotificationIcon } from '../../../../../../assets/vectors/notifications.svg';
import { ReactComponent as UserCircleIcon } from '../../../../../../assets/vectors/user_circle.svg';
import { useCurrentUser } from '../../../../../../hooks/useCurrentUser/useCurrentUser';
import { getUserRoleLabel } from '../../../../../../utils/helpers/user/getUserRoleLabel';
import useComponentVisible from '../../../../../../hooks/useComponentVisible/useComponentVisible';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import { signOut } from '../../../../../../store/authentication/authenticationActions/authenticationActions';
import { useCurrentLogo } from '../../../../../../hooks/fetchers/useCurrentLogo/useCurrentLogo';
import { useEffect } from 'react';
import { UserRoles } from '../../../../../../types/models/user/user.types';

export default () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const navigate = useNavigate();

  const currentUser = useCurrentUser();

  const { data: userLogo, refetch } = useCurrentLogo({ enabled: false });

  const roleLabel = getUserRoleLabel(currentUser?.role);

  const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);

  useEffect(() => {
    if (currentUser?.role === UserRoles.Entreprise) {
      refetch()
    }
  }, [currentUser])

  return (
    <section className="dashboard__header">
      <div className="dashboard__header-main">
        <div className="flex-column">
          <h3>Tableau de bord</h3>
          <span className="dashboard__header-main-date">
            {moment().format('dddd DD MMMM YYYY')}
          </span>
        </div>
        <NotificationIcon className="dashboard__header-main-notifications-icon" />
      </div>
      <div
        ref={ref}
        className="dashboard__header-account"
        onClick={() => setIsComponentVisible(true)}>
        {
          userLogo
            ?
            <img src={URL.createObjectURL(userLogo)} />
            :
            <UserCircleIcon className="dashboard__header-account-image" />
        }
        <div className="flex-column">
          <label className="dashboard__header-account-name">
            {currentUser?.firstName} {currentUser?.lastName}
          </label>
          <span className="dashboard__header-account-role">{roleLabel}</span>
          <div className="dashboard__header-account-menu-container">
            {isComponentVisible && (
              <div className={`dashboard__header-account-menu`}>
                <span onClick={() => navigate('/profile')}>Mon Profil</span>
                <span
                  onClick={() => {
                    signOut(queryClient)(dispatch);
                    navigate('/');
                  }}>
                  Se déconnecter
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
